module.exports = __webpack_public_path__ + "static/td_home_banner_meta-2cae6fd786bf670d924ba4c3768927cc.jpg";